import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class CustomerService extends CrudService {
  constructor() {
    super('customers')
  }

  confirmCustomer = async (id) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/confirm`)
      return response.data
    } catch (error) {
      console.error(`Error confirming customer with id ${id}`, error)
      throw error
    }
  }
  toggleActiveCustomer = async (id) => {
    try {
      const response = await axios.patch(`/${this.resource}/${id}/toggle-active`)
      return response.data
    } catch (error) {
      console.error(`Error confirming customer with id ${id}`, error)
      throw error
    }
  }
  createTemporaryCustomer = async (data) => {
    try {
      const response = await axios.post(`/${this.resource}/temporary`, data)
      return response.data
    } catch (error) {
      console.error(`Error creating temporary customer.`, error)
      throw error
    }
  }
  upload = async (file) => {
    try {
      const form = new FormData()
      form.append('file', file)

      const response = await axios.post(`${this.resource}/upload`, form)

      return response.data
    } catch (error) {
      console.error(`Error uploading customer`, error)
      throw error
    }
  }
}

export default CustomerService
